import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { Thermostat } from '@mui/icons-material'
import AuroraAssetGroupHeatPumpStatusControl from './AuroraAssetGroupHeatPumpStatusControl'
import AuroraAssetGroupHeatPumpModeControl from './AuroraAssetGroupHeatPumpModeControl'
import AuroraControlGroup from './AuroraControlGroup'
import { AuroraAssetGroup } from '../types'

interface AuroraAssetGroupHeatPumpControlsProps {
  auroraAssetGroup: AuroraAssetGroup
}

export default function AuroraAssetGroupHeatPumpControls({
  auroraAssetGroup
}: AuroraAssetGroupHeatPumpControlsProps) {
  const { t } = useTranslation('aurora')

  const theme = useTheme()

  return (
    <AuroraControlGroup
      label={t('heatPumpControl')}
      icon={<Thermostat htmlColor={theme.palette.text.secondary} />}
    >
      {/*<AuroraAssetGroupHeatPumpStatusControl auroraAssetGroup={auroraAssetGroup} />*/}
      <AuroraAssetGroupHeatPumpModeControl auroraAssetGroup={auroraAssetGroup} />
    </AuroraControlGroup>
  )
}
